import { config, authHeader, handleResponse } from '../helpers'

export const reviewService = {
   projectSubmission,
   getProjects,
   updateOrSaveGrade,
   getProjectGrades,
   getProject,
   getProjectsVideoCodeEval,
   updateOrSaveVideoCodeGrade ,
   getVideoCodeProjects,
   getVideoCodeProjectByID,
//    updateOrSavePrototypeReview,
  

}

function projectSubmission() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${config.baseUrl}/review/submission-status`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })

}

function getProjects(page) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${config.baseUrl}/review/projects?page=${page}`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}
function getVideoCodeProjects(page){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${config.baseUrl}/review/video-code-projects?page=${page}`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}

function getProject(projectId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${config.baseUrl}/review/projects?projectId=${projectId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}

function getVideoCodeProjectByID(projectId){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${config.baseUrl}/review/video-code-projects?projectId=${projectId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}


function updateOrSaveGrade(projectId, reviewerId, grade) {
    const params ={
        projectId:projectId,
            reviewerId:reviewerId,
              grade
    }

    //IMPORTANT if using POST with api middleware use application/json;charset=UTF-8 and stringify the body

    const requestOptions = {
        method: 'POST',
        headers: {...authHeader(),
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
        } ,
        body: JSON.stringify(params)
    }

    return fetch(`${config.baseUrl}/reviewer/update-grade`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}



function getProjectGrades(){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${config.baseUrl}/review/project-grades`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        }).catch(
            error => error
        )
}

function getProjectsVideoCodeEval(){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`${config.baseUrl}/review/project-alloted`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data
    }).catch(
        error => error
    )
}

function updateOrSaveVideoCodeGrade(projectId, reviewerId, grade){
    const params ={
        projectId:projectId,
        reviewerId:reviewerId,
        grade
    }
    const requestOptions = {
        method: 'POST',
        headers: {...authHeader(),
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
        } ,
        body: JSON.stringify(params)
    }

    return fetch(`${config.baseUrl}/review/update-videocode-grade`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}



function updateOrSavePrototypeReview(projectId, reviewerId, prototypeReview) {
    const params ={
        projectId:projectId,
        reviewerId:reviewerId,
        prototypeReview
    }

    //IMPORTANT if using POST with api middleware use application/json;charset=UTF-8 and stringify the body

    const requestOptions = {
        method: 'POST',
        headers: {...authHeader(),
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
        } ,
        body: JSON.stringify(params)
    }

    return fetch(`${config.baseUrl}/review/update-proto-review`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}





